import Sparkle from "./Sparkle";

const LOGO_URL = "/brand/IMG_2238.PNG";

// Brand logo for Shay Cooks LLC.
// `variant`:
//   - "badge"    (default): logo on a navy circular badge — works on ANY background.
//   - "plain"    : logo only, no backdrop — use on guaranteed-dark backgrounds (footer, loading).
//   - "wordmark" : text fallback with sparkles.
// `size`: sm | md | nav | lg | xl
export const Logo = ({ variant = "badge", size = "md", className = "", src = LOGO_URL }) => {
  const imgHeights = {
    sm: "h-9 md:h-10",
    md: "h-11 md:h-12",
    nav: "h-14 md:h-16",
    lg: "h-16 md:h-20",
    xl: "h-28 md:h-36",
  };

  const badgeSizes = {
    sm: "h-12 w-12 md:h-14 md:w-14",
    md: "h-14 w-14 md:h-16 md:w-16",
    nav: "h-16 w-16 md:h-20 md:w-20",
    lg: "h-20 w-20 md:h-24 md:w-24",
    xl: "h-32 w-32 md:h-40 md:w-40",
  };

  if (variant === "wordmark") {
    return (
      <div className={`relative inline-flex items-center gap-2 leading-none ${className}`} data-testid="shay-logo">
        <Sparkle size={14} color="#05071A" className="opacity-70" />
        <span className="font-display text-shay-navy text-2xl md:text-[1.65rem] font-black tracking-tight">
          Shay
        </span>
        <span className="font-display text-shay-gold text-2xl md:text-[1.65rem] font-black italic tracking-tight">
          Cooks
        </span>
        <Sparkle size={14} color="#05071A" className="opacity-70" />
      </div>
    );
  }

  const img = (
    <img
      src={src}
      alt="Shay Cooks LLC — Did You Eat?"
      className={`${imgHeights[size]} w-auto block select-none`}
      draggable={false}
      decoding="async"
      style={{ objectFit: "contain" }}
    />
  );

  if (variant === "plain") {
    return (
      <div className={`inline-flex items-center ${className}`} data-testid="shay-logo" aria-label="Shay Cooks LLC">
        {img}
      </div>
    );
  }

  // "badge" — navy backdrop with subtle gold ring; works on any background.
  return (
    <div
      className={`relative inline-flex items-center justify-center overflow-hidden rounded-full bg-shay-navy ring-1 ring-shay-gold/40 shadow-[0_8px_24px_-12px_rgba(5,7,26,0.5)] ${badgeSizes[size]} ${className}`}
      data-testid="shay-logo"
      aria-label="Shay Cooks LLC"
    >
      <img
        src={src}
        alt="Shay Cooks"
        className="block h-[82%] max-h-full w-[82%] max-w-full select-none object-contain"
        draggable={false}
        decoding="async"
      />
    </div>
  );
};

export default Logo;
